export const HIERARCHY_SHOOT_TYPE = {
  PORTRAIT: 'PORTRAIT',
  ACTION: 'ACTION',
  PORTRAIT_AND_ACTION: 'PORTRAIT_AND_ACTION',
};
